import clsx from 'clsx'
import { CheckIcon } from 'lucide-react'
import { type ReactNode } from 'react'

import { UnderlinedTooltip } from 'components/ui/UnderlinedTooltip'

interface DataItemProps {
  label: string
  value: string | number | string[] | ReactNode
  size?: 'sm' | 'lg'
  tooltip?: ReactNode
  sensitive?: boolean
}

export const CheckIconList = ({ items }: { items: ReactNode[] }) => (
  items.map((item, index) => (
    <div key={index} className='flex gap-2'>
      <CheckIcon className='w-4 h-4 flex-shrink-0 text-ds-icon-success' />
      <p className='text-main'>{item}</p>
    </div>
  ))
)

export const DataItem = ({ label, value, size = 'sm', sensitive, tooltip }: DataItemProps) => {
  const valueSizeClass = size === 'sm' ? 'text-sm' : 'text-xl font-medium'
  return (
    <div className='flex flex-col gap-1'>
      <UnderlinedTooltip content={tooltip} enabled={!!tooltip} className='w-fit' withPortal={false}>
        <dt className='body-sm text-gray-500'>{label}</dt>
      </UnderlinedTooltip>
      <dd
        className={clsx('body text-gray-800', valueSizeClass, {
          sensitive
        })}
      >
        {Array.isArray(value) ? <CheckIconList items={value} /> : value}
      </dd>
    </div>
  )
}
